"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var Logout = mobx_react_1.observer(function () {
    var userStore = use_stores_1.useStores().userStore;
    react_1.useEffect(function () {
        api_1.default.logout()
            .then(function (response) { offYouFuck(); }, function (error) { offYouFuck(); })
            .catch(function (error) { offYouFuck(); });
    }, []);
    var offYouFuck = function () {
        setTimeout(function () {
            userStore.unsetData();
            location.reload();
        }, 2000);
    };
    return (react_1.default.createElement("div", { className: 'logout page flex flex-column flex-center' },
        react_1.default.createElement("span", { className: 'bye' }, "Bye!")));
});
exports.default = Logout;
